import { render } from "./CounselingReportCopy.vue?vue&type=template&id=95f9a53c&ts=true"
import script from "./CounselingReportCopy.vue?vue&type=script&lang=ts"
export * from "./CounselingReportCopy.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__